import { render, staticRenderFns } from "./AttendeesCard.vue?vue&type=template&id=32b7bcbe&lang=pug"
import script from "./AttendeesCard.vue?vue&type=script&lang=js"
export * from "./AttendeesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports